module.exports = __webpack_public_path__ + "static/img/modernWeb19.041c0b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/modernWeb19.jpg
// module id = dwvP
// module chunks = 1